import React from 'react';
import { Typography } from 'common/components';
import { createElementKey } from 'utils';
import { FEATURES_LIST, FeatureStructure } from './features-section-constants';
import { feature, featureIcon, featureText, featuresSection } from './features-section-styles';

/**
 * Вью секции со списком особенностей разработки инженерных систем
 */
export const FeaturesSection = () => (
  <section className={featuresSection}>
    {FEATURES_LIST.map(({ imgSrc, alt, description }: FeatureStructure, index: number) => (
      <div className={feature} key={createElementKey('feature', index)}>
        <img alt={alt} className={featureIcon} src={imgSrc} title={alt} />
        <Typography className={featureText} variant="m" size="body_long">
          {description}
        </Typography>
      </div>
    ))}
  </section>
);
